import { AuthEvent } from './types';

type Listener = (evt: AuthEvent) => void;

export class AuthEmitter {
  private listeners: Set<Listener> = new Set();
  on(listener: Listener) { this.listeners.add(listener); return () => this.off(listener); }
  off(listener: Listener) { this.listeners.delete(listener); }
  emit(evt: AuthEvent) { for (const l of Array.from(this.listeners)) { try { l(evt); } catch { /* swallow */ } } }
}

export const authEmitter = new AuthEmitter();
